/**
 * @generated SignedSource<<d79d572af7cfd784c4bc62a7ea20a2f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewText_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "AnswerText",
  "abstractKey": null
};

node.hash = "60fe9574023974402bbb51e53b2edccd";

module.exports = node;
